import EA from '../helpers/init';

export default EA.Methods.sticky = ($this) => {
    const sections = document.querySelectorAll('section:not(.sticky-section)');
    const footer = document.querySelector('footer');
    const app = document.querySelector('.app');
    const mq = window.matchMedia('(min-width: 1000px)');

    function handleOverflow() {
        if (mq.matches) {
            app.classList.add('overflow-visible');
            footer.classList.add('overflow');
            sections.forEach(section => {
                section.classList.add('overflow');
            });
        } else {
            app.classList.remove('overflow-visible');
            footer.classList.remove('overflow');
            sections.forEach(section => {
                section.classList.remove('overflow');
            });
        };
    };

    handleOverflow();

    window.addEventListener('load', handleOverflow);
    window.addEventListener('resize', handleOverflow);
};
